export default __webpack_public_path__ + "static/TX2-ES-e93c87e6f0f47d77696e46a7f758677f.svg";